import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {NavigationService} from "./core/navigation/navigation.service";
import {UserService} from "./core/user/user.service";
import {AuthService} from "./auth/auth.service";

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(
        private _navigationService: NavigationService,
        private _userService: UserService,
        private _authService: AuthService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Načte profil a položky hlavního menu (`NavigationService`)
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>
    {

        // Kvůli "Too Many Attempts."
        if(state?.url === '/500-internal-server-error'){
            return this._navigationService.get();
        }

        return this._authService.profile().pipe(
            switchMap(() => this._navigationService.get())
        );

        //return this._navigationService.get();
        //return of(true);
    }
}
